export function debounce(func: Function, wait: number, immediate: boolean = false): EventListener {
  let timeout: number

  return function (): void {
    /* tslint:disable-next-line */
    const context: any = this;
    const args: any = arguments

    const later: Function = function (): void {
      timeout = null

      if (!immediate) {
        func.apply(context, args)
      }
    }

    const callNow: boolean = immediate && !timeout

    clearTimeout(timeout)

    timeout = setTimeout(later, wait)

    if (callNow) {
      func.apply(context, args)
    }
  }
}
